/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import type { ReactNode } from 'react';
import { usePreferredTheme } from './usePreferredTheme';

/** Collapses every CSS animation and transition (windows, dock, panels, toasts) to an instant. */
const reducedMotionStyles = {
  '*, *::before, *::after': {
    animationDuration: '0.01ms !important',
    animationIterationCount: '1 !important',
    transitionDuration: '0.01ms !important',
    scrollBehavior: 'auto !important',
  },
} as const;

/** Applies the user's theme, accent color and reduce-motion preference. */
export const PreferredThemeProvider = ({ children }: Readonly<{ children: ReactNode }>) => {
  const { theme, reduceMotion } = usePreferredTheme();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {reduceMotion && <GlobalStyles styles={reducedMotionStyles} />}
      {children}
    </ThemeProvider>
  );
};
